import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Grid, Switch } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { useNavigate } from 'react-router-dom';

import * as routing from '../../../../constants/Routing';
import { PLAN_TYPE } from '../../../../constants/Subscriptions';
import { Project } from '../../../../domain/project/Project';
import { useRetrieveOrganization } from '../../../../hooks/organization/useRetrieveOrganization';
import { useUpdateProject } from '../../../../hooks/project/useUpdateProject';
import ProjectCustomersMapper from '../../../../mappers/project/ProjectCustomersMapper';
import { Accordion } from '../../../../react-components/Accordion';
import Text from '../../../../react-components/Text';

interface CustomersPINProps {
  project: Project;
}

export const CustomersPIN = ({ project }: CustomersPINProps) => {
  const navigate = useNavigate();
  const { data: organization } = useRetrieveOrganization();
  const { run: editProject } = useUpdateProject({ project });

  const hasSubscriptionPermissions = () => {
    return organization?.subscription?.plan !== PLAN_TYPE.MONKEY;
  };

  const isEnabledInDrivers = (): boolean => {
    return project.drivers.hasPinEnabled();
  };

  const isEnabledInCustomers = (): boolean => {
    return Boolean(project.customers.fields.find((field) => field.id === `pin`));
  };
  Math.round(100 * Math.random());

  return (
    <div
      style={{
        border: `1px solid #E0E0E0`,
        borderRadius: `2px`,
      }}
    >
      <Accordion
        id="customers_app_pin"
        expanded
        headerStyles={{
          position: `relative`,
          paddingTop: `16px`,
        }}
        headerContent={
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            style={{ marginTop: `-8px` }}
          >
            <Text style={{ cursor: `pointer` }} variant="body-large" isBold intlId="customers.app.options.pin" />

            <span onClick={(event) => event.stopPropagation()}>
              <Switch
                disabled={!isEnabledInDrivers()}
                checked={isEnabledInCustomers()}
                value={isEnabledInCustomers()}
                onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                  const projectCustomers = ProjectCustomersMapper.toDTO(project.customers);

                  if (!checked) {
                    projectCustomers.fields = projectCustomers.fields.filter((field) => field.id !== `pin`);
                  } else {
                    projectCustomers.fields.push({
                      id: `pin`,
                      type: `string`,
                    });
                  }

                  editProject({
                    customers: ProjectCustomersMapper.toDomain(projectCustomers),
                  });
                }}
                color="primary"
              />
            </span>
          </Grid>
        }
      >
        {!hasSubscriptionPermissions() ? (
          <Grid
            container
            direction="row"
            wrap="nowrap"
            alignItems="center"
            style={{ backgroundColor: `#5073B5`, padding: `8px 16px` }}
          >
            <Grid item>
              <ArrowUpwardIcon style={{ fontSize: `20px`, color: RoutalPalette.neutral00 }} />
            </Grid>
            <Grid item>
              <Text
                style={{
                  fontSize: `12px`,
                  color: RoutalPalette.neutral00,
                  textAlign: `center`,
                }}
                intlId="customers.app.options.pin.upgrade"
              />
            </Grid>
          </Grid>
        ) : (
          <>
            {!isEnabledInDrivers() ? (
              <Grid
                container
                direction="column"
                style={{ backgroundColor: RoutalPalette.secondary20n, padding: `8px 16px` }}
              >
                <Grid item>
                  <Text
                    style={{
                      fontSize: `12px`,
                    }}
                    intlId="customers.app.options.pin.disabled"
                    intlValues={{
                      a: (chunks: any) => (
                        <Text
                          isBold
                          tagName="span"
                          variant="button"
                          onClick={() => navigate(routing.DRIVERS.APP.CONFIGURATION.replace(`:projectId`, project.id))}
                        >
                          {chunks}
                        </Text>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            ) : null}
          </>
        )}

        <div
          style={{
            ...(isEnabledInDrivers() ? { borderTop: `1px solid #E0E0E0` } : {}),
            padding: `16px`,
          }}
        >
          <Text variant="label" intlId="customers.app.options.pin.info" />
          <VSpacer small />
        </div>
      </Accordion>
    </div>
  );
};
